import React, { useCallback } from 'react';
import { toggleId, useSelectionContext } from './bn-selection-context';
import { Checkbox, makeStyles } from '~/lib/bn-material-ui';

const useStyles = makeStyles(() => ({
  selectionCheckbox: {
    padding: 0,
  },
}));

export default function BnSelectionCheckbox({ id, disableOnSelectAll = true, disabled: callerDisabled }) {
  const styles = useStyles();
  const [selectionState, dispatchSelection] = useSelectionContext();
  const checked = selectionState.allSelected || ((id && selectionState.selectedIds[id]) || false);
  const disabled = callerDisabled || (disableOnSelectAll && selectionState.allSelected);

  const onChange = useCallback(
    function onChange() {
      dispatchSelection(toggleId(id));
    }, [id, dispatchSelection]);

  return <Checkbox className={styles.selectionCheckbox} disabled={disabled} checked={checked} onChange={onChange} title={checked ? 'Selected' : 'Click to Select'}/>;
}
